import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Icon from '../../components/AppIcon';
import LocationCard from './components/LocationCard';
import LocationMap from './components/LocationMap';
import LocationFilters from './components/LocationFilters';
import CertificationBadge from './components/CertificationBadge';
import DeliveryPartners from './components/DeliveryPartners';
import QuickActions from './components/QuickActions';

const Locations = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [filteredLocations, setFilteredLocations] = useState([]);

  const locations = [
  {
    id: 1,
    name: "Taco Street Indiranagar",
    area: "Indiranagar",
    address: "100 Feet Road, Near Metro Station, Indiranagar, Bengaluru - 560038",
    phone: "+91 80 4567 8901",
    hours: "11:00 AM - 11:00 PM",
    status: "Open",
    rating: 4.5,
    waitTime: "15-20 mins",
    capacity: 65,
    lat: 12.9716,
    lng: 77.6412,
    image: "https://images.unsplash.com/photo-1654074520257-e842c6182a44",
    imageAlt: "Modern restaurant interior with warm lighting, wooden tables, comfortable seating, and vibrant Mexican decor in Indiranagar location",
    parking: "Valet parking available",
    isNew: false,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'ParkingCircle', label: 'Parking' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Users', label: 'Group Dining' }]

  },
  {
    id: 2,
    name: "Taco Street Koramangala",
    area: "Koramangala",
    address: "5th Block, 80 Feet Road, Koramangala, Bengaluru - 560095",
    phone: "+91 80 4567 8902",
    hours: "11:00 AM - 12:00 AM",
    status: "Open",
    rating: 4.7,
    waitTime: "10-15 mins",
    capacity: 45,
    lat: 12.9352,
    lng: 77.6245,
    image: "https://images.unsplash.com/photo-1668000305847-cf422c116bf8",
    imageAlt: "Spacious restaurant dining area with contemporary design, ambient lighting, bar counter, and colorful Mexican artwork in Koramangala",
    parking: "Street parking available",
    isNew: false,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Music', label: 'Live Music' },
    { icon: 'Beer', label: 'Bar' }]

  },
  {
    id: 3,
    name: "Taco Street Whitefield",
    area: "Whitefield",
    address: "ITPL Main Road, Near Forum Mall, Whitefield, Bengaluru - 560066",
    phone: "+91 80 4567 8903",
    hours: "11:00 AM - 11:00 PM",
    status: "Open",
    rating: 4.6,
    waitTime: "20-25 mins",
    capacity: 80,
    lat: 12.9698,
    lng: 77.7499,
    image: "https://images.unsplash.com/photo-1723642613239-8e980aa0f62b",
    imageAlt: "Large restaurant space with open kitchen concept, modern furniture, natural lighting, and vibrant atmosphere in Whitefield location",
    parking: "Multi-level parking available",
    isNew: true,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'ParkingCircle', label: 'Parking' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Baby', label: 'Kid Friendly' }]

  },
  {
    id: 4,
    name: "Taco Street HSR Layout",
    area: "HSR Layout",
    address: "27th Main Road, Sector 1, HSR Layout, Bengaluru - 560102",
    phone: "+91 80 4567 8904",
    hours: "11:00 AM - 11:00 PM",
    status: "Closing Soon",
    rating: 4.4,
    waitTime: "15-20 mins",
    capacity: 55,
    lat: 12.9121,
    lng: 77.6446,
    image: "https://images.unsplash.com/photo-1624583338957-4d155ca886dc",
    imageAlt: "Cozy restaurant interior with rustic wooden decor, comfortable booth seating, warm ambient lighting, and Mexican cultural elements",
    parking: "Limited street parking",
    isNew: false,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Coffee', label: 'Cafe' }]

  },
  {
    id: 5,
    name: "Taco Street MG Road",
    area: "MG Road",
    address: "Brigade Road Junction, MG Road, Bengaluru - 560001",
    phone: "+91 80 4567 8905",
    hours: "11:00 AM - 12:00 AM",
    status: "Open",
    rating: 4.8,
    waitTime: "25-30 mins",
    capacity: 90,
    lat: 12.9716,
    lng: 77.6147,
    image: "https://images.unsplash.com/photo-1722268096649-72a6a0c4dfb5",
    imageAlt: "Premium restaurant setting with elegant decor, sophisticated lighting, spacious dining area, and upscale Mexican ambiance on MG Road",
    parking: "Paid parking nearby",
    isNew: false,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'ParkingCircle', label: 'Parking' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Music', label: 'Live Music' },
    { icon: 'Beer', label: 'Bar' }]

  },
  {
    id: 6,
    name: "Taco Street Jayanagar",
    area: "Jayanagar",
    address: "4th Block, 11th Main Road, Jayanagar, Bengaluru - 560011",
    phone: "+91 80 4567 8906",
    hours: "11:00 AM - 11:00 PM",
    status: "Closed",
    rating: 4.3,
    waitTime: null,
    capacity: null,
    lat: 12.9250,
    lng: 77.5937,
    image: "https://images.unsplash.com/photo-1632258584901-5458887dd0df",
    imageAlt: "Family-friendly restaurant with spacious layout, bright lighting, comfortable seating arrangements, and welcoming Mexican decor in Jayanagar",
    parking: "Valet parking available",
    isNew: true,
    amenities: [
    { icon: 'Wifi', label: 'Free WiFi' },
    { icon: 'ParkingCircle', label: 'Parking' },
    { icon: 'Truck', label: 'Delivery' },
    { icon: 'Baby', label: 'Kid Friendly' },
    { icon: 'Users', label: 'Group Dining' }]

  }];


  useEffect(() => {
    filterLocations();
  }, [activeFilter]);

  useEffect(() => {
    if (locations?.length > 0) {
      setSelectedLocation(locations?.[0]);
    }
  }, []);

  const filterLocations = () => {
    let filtered = [...locations];

    switch (activeFilter) {
      case 'open':
        filtered = filtered?.filter((loc) => loc?.status === 'Open');
        break;
      case 'parking':
        filtered = filtered?.filter((loc) =>
        loc?.amenities?.some((a) => a?.icon === 'ParkingCircle')
        );
        break;
      case 'wifi':
        filtered = filtered?.filter((loc) =>
        loc?.amenities?.some((a) => a?.icon === 'Wifi')
        );
        break;
      case 'delivery':
        filtered = filtered?.filter((loc) =>
        loc?.amenities?.some((a) => a?.icon === 'Truck')
        );
        break;
      default:
        break;
    }

    setFilteredLocations(filtered);
  };

  const handleGetDirections = (location) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${location?.lat},${location?.lng}`,
      '_blank'
    );
  };

  const handleCallNow = (location) => {
    window.location.href = `tel:${location?.phone}`;
  };

  const handleViewMenu = () => {
    navigate('/menu');
  };

  const handleOrderNow = () => {
    navigate('/menu');
  };

  const handleReserveTable = () => {
    alert('Reservation system coming soon! Please call your preferred location to reserve a table.');
  };

  const handleCatering = () => {
    alert('For catering inquiries, please contact any of our locations directly.');
  };

  const handleFilterChange = (filterId) => {
    setActiveFilter(filterId);
  };

  const handleClearFilters = () => {
    setActiveFilter('all');
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <title>Our Locations - Taco Street Digital | Find Your Nearest Branch</title>
        <meta
          name="description"
          content="Find Taco Street locations across Bengaluru. Visit us in Indiranagar, Koramangala, Whitefield, HSR Layout, MG Road, and Jayanagar for authentic Mexican street food." />

      </Helmet>
      <Header />
      <main className="main-content bg-[var(--color-background)]">
        <section className="relative bg-gradient-to-br from-[var(--color-primary)]/10 to-[var(--color-accent)]/10 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 bg-[var(--color-primary)]/10 text-[var(--color-primary)] px-4 py-2 rounded-full text-sm font-semibold mb-4">
                <Icon name="MapPin" size={16} />
                6 Locations Across Bengaluru
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-[var(--color-foreground)] mb-4">
                Find Your Nearest Taco Street
              </h1>
              <p className="text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
                Experience authentic Mexican street food at any of our convenient locations across Bengaluru. Fresh ingredients, halal certified, and always delicious.
              </p>
            </div>

            <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)] mb-8">
              <div className="h-96 rounded-lg overflow-hidden">
                <LocationMap location={selectedLocation} />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              <div className="lg:col-span-1 space-y-6">
                <LocationFilters
                  activeFilter={activeFilter}
                  onFilterChange={handleFilterChange}
                  onClearFilters={handleClearFilters} />

                <CertificationBadge />
                <DeliveryPartners />
              </div>

              <div className="lg:col-span-3">
                <div className="mb-6">
                  <h2 className="text-2xl font-bold text-[var(--color-foreground)] mb-2">
                    {activeFilter === 'all' ? 'All Locations' : `Filtered Locations (${filteredLocations?.length})`}
                  </h2>
                  <p className="text-[var(--color-muted-foreground)]">
                    Click on any location to view on map
                  </p>
                </div>

                {filteredLocations?.length === 0 ?
                <div className="bg-[var(--color-card)] rounded-xl p-12 text-center border border-[var(--color-border)]">
                    <Icon name="MapPin" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-[var(--color-foreground)] mb-2">
                      No locations found
                    </h3>
                    <p className="text-[var(--color-muted-foreground)] mb-4">
                      Try adjusting your filters to see more locations
                    </p>
                    <button
                    onClick={handleClearFilters}
                    className="text-[var(--color-primary)] hover:underline font-medium">

                      Clear all filters
                    </button>
                  </div> :

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {filteredLocations?.map((location) =>
                  <div key={location?.id} onClick={() => handleLocationSelect(location)}>
                        <LocationCard
                      location={location}
                      onGetDirections={handleGetDirections}
                      onCallNow={handleCallNow}
                      onViewMenu={handleViewMenu} />

                      </div>
                  )}
                  </div>
                }
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-[var(--color-muted)]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <QuickActions
              onOrderNow={handleOrderNow}
              onReserveTable={handleReserveTable}
              onCatering={handleCatering} />

          </div>
        </section>

        <section className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[var(--color-foreground)] mb-4">
                Why Choose Taco Street?
              </h2>
              <p className="text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
                More than just great food, we offer an authentic experience
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)] text-center">
                <div className="w-16 h-16 rounded-full bg-[var(--color-primary)]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="ShieldCheck" size={32} color="var(--color-primary)" />
                </div>
                <h3 className="text-xl font-semibold text-[var(--color-foreground)] mb-2">
                  100% Halal Certified
                </h3>
                <p className="text-[var(--color-muted-foreground)]">
                  All our ingredients are halal certified and verified for your peace of mind
                </p>
              </div>

              <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)] text-center">
                <div className="w-16 h-16 rounded-full bg-[var(--color-primary)]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Leaf" size={32} color="var(--color-primary)" />
                </div>
                <h3 className="text-xl font-semibold text-[var(--color-foreground)] mb-2">
                  Fresh Daily Preparation
                </h3>
                <p className="text-[var(--color-muted-foreground)]">
                  Everything is prepared fresh daily with the highest quality ingredients
                </p>
              </div>

              <div className="bg-[var(--color-card)] rounded-xl p-6 border border-[var(--color-border)] text-center">
                <div className="w-16 h-16 rounded-full bg-[var(--color-primary)]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Heart" size={32} color="var(--color-primary)" />
                </div>
                <h3 className="text-xl font-semibold text-[var(--color-foreground)] mb-2">
                  Community Focused
                </h3>
                <p className="text-[var(--color-muted-foreground)]">
                  We're more than a restaurant - we're a gathering place for food lovers
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>);

};

export default Locations;